import { atom } from "jotai";

import { AbstractShop } from "~/shared/shipping/abstract-shop.interface";

export const storeModalAtom = atom<boolean>(false);

export const collectInStoreSelected = atom<boolean>(false);

export const selectedStoreAtom = atom<AbstractShop | undefined>(undefined);
